export const FORM = '@@auth/FORM';
export const MODAL = '@@auth/MODAL';

export const USER_LOGIN = '@@auth/USER_LOGIN';
export const USER_REGISTER = '@@auth/USER_REGISTER';



// WEBPACK FOOTER //
// ./src/app/Auth/actionTypes.js